module.exports = __webpack_public_path__ + "static/zzs_fjj-71cf18378a69f950354cda168ecb9eca.png";